import React, { useRef, useState } from "react";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import Button from "../UniversalComponents/DefaultButton";
import InputComponent from "../UniversalComponents/InputComponent";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import BlankListIcon from "../../assets/images/icons/BlankListIcon";
import FromExcelIcon from "../../assets/images/icons/FromExcelIcon";
import FromCsvIcon from "../../assets/images/icons/FromCsvIcon";
import CloseIcon from "@mui/icons-material/Close";
import { mySpaceAddList, mySpaceCsvUpload } from "../../utils/api/mySpaceApi";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import LabelComponent from "../UniversalComponents/LabelComponent";

export default function CreateListDrawer({
  open,
  onClose,
  onSuccess = () => {},
  onError = () => {},
  folderId = null,
  setShowCsvUploadPreview,
  csvFileData,
  setCsvFileData,
}) {
  const [listName, setListName] = useState("");
  const [listDescription, setListDescription] = useState("");
  const [activeSection, setActiveSection] = useState("list");
  // const [activeCsvSection, setActiveCsvSection] = useState("csv");
  const [isHovered, setIsHovered] = useState(false);
  const [isExcelHovered, setExcelHovered] = useState(false);
  const [isCsvHovered, setCsvHovered] = useState(false);
  const [formErrorData, setFormErrorData] = useState({});
  const [apiLoading, setApiLoading] = useState(false);
  const dispatch = useDispatch();

  const inputExcelRef = useRef(null);
  const inputCsvRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const [fileCsvName, setFileCsvName] = useState("");

  const openFilePicker = () => {
    inputExcelRef.current?.click();
  };
  const openFileCsvPicker = () => {
    inputCsvRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileName = file.name.toLowerCase();
      if (fileName.endsWith(".csv")) {
        setFileName(file);
      } else {
        dispatch(pushAlert({ type: "danger", message: "Please upload a valid CSV file.", visible: true }));
        e.target.value = "";
      }
    }
  };

  const handleFileCsvChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileName = file.name.toLowerCase();
      if (fileName.endsWith(".csv")) {
        setShowCsvUploadPreview(true);
        setCsvFileData(file);
        setFileCsvName(file);
      } else {
        dispatch(pushAlert({ type: "danger", message: "Please upload a valid CSV file.", visible: true }));
        e.target.value = "";
      }
    }
  };

  const handleClearExcelFileInput = () => {
    setFileName("");
    inputExcelRef.current.value = null;
  };
  const handleClearCsvFileInput = () => {
    setFileCsvName("");
    inputCsvRef.current.value = null;
  };

  const handleCreateList = async (listName, description) => {
    try {
      let response;
      setApiLoading(true);
      const body = {
        name: listName,
        description: description,
      };

      if (folderId) {
        body.parent_id = folderId;
      }

      if (activeSection === "list") {
        if (listName === "" || listName === null || listName === undefined) {
          setFormErrorData({ listname: true });
          dispatch(pushAlert({ type: "danger", message: "Please enter a list name", visible: true }));
          return;
        }
        response = await mySpaceAddList({ body });
      } else if (activeSection === "excel") {
        dispatch(pushAlert({ type: "info", message: response?.message, visible: true }));
      } else if (activeSection === "csv") {
        const formData = new FormData();
        formData.append("file", fileCsvName);
        response = await mySpaceCsvUpload({ body: formData, query: { parentId: folderId } });
      }

      if (response?.success) {
        dispatch(pushAlert({ type: "success", message: response?.message, visible: true }));
        onSuccess();
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message, visible: true }));
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error?.message, visible: true }));
    } finally {
      setApiLoading(false);
    }
  };

  return (
    <CustomDrawer open={open} onClose={onClose}>
      <div className="flex flex-col grow min-h-0 ">
        {/* HEADER */}
        <div className=" flex items-center justify-between py-3 px-3 border-b border-BECBD3 ">
          <h3 className="text-lg font-medium text-434852">Create Table</h3>
          <button
            onClick={onClose}
            type="button"
            className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
            data-modal-hide="assets-modal"
          >
            <CloseModalImg className="w-3 h-3" />
            <span className="sr-only">Close modal</span>
          </button>
        </div>

        {/* BODY */}
        <div className="grow min-h-0 flex flex-col">
          <div className="bg-gray flex gap-3 pt-4 px-5 bg-[#F3F5F7] py-3 ">
            <div
              onClick={() => setActiveSection("list")}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              className={`flex flex-col items-center justify-center gap-1 cursor-pointer border ${
                activeSection === "list" ? "border-[#1D4469]" : "border-gray-300"
              } hover:border-[#1D4469] group rounded-md p-2 w-28 h-28`}
            >
              <BlankListIcon isActive={activeSection === "list"} isHovered={isHovered} />
              {console.log(activeSection, "helloActive")}

              <span
                className={` pt-3  font-600 text-12 ${
                  activeSection === "list" ? "text-[#1D4469]" : "text-gray-600"
                } group-hover:text-[#1D4469]`}
              >
                Blank Table
              </span>
            </div>

            <div
              onClick={() => setActiveSection("csv")}
              onMouseEnter={() => setCsvHovered(true)}
              onMouseLeave={() => setCsvHovered(false)}
              className={`flex flex-col items-center justify-center gap-1 cursor-pointer border ${
                activeSection === "csv" ? "border-[#1D4469]" : "border-gray-300"
              } hover:border-[#1D4469] group rounded-md p-2 w-28 h-28`}
            >
              <FromCsvIcon isActive={activeSection === "csv"} isCsvHovered={isCsvHovered} />

              <span
                className={`text-12 pt-3   font-600  ${
                  setActiveSection === "csv" ? "text-[#1D4469]" : "text-gray-600"
                } group-hover:text-[#1D4469]`}
              >
                From CSV
              </span>
            </div>
          </div>

          {activeSection === "list" && (
            <div className="px-3">
              <div className="pt-4  ">
                <LabelComponent
                  labelText={"Name"}
                  isMandatory={true}
                  className={`block  text-535252 text-14 font-500 mb-1`}
                />
                <InputComponent
                  type="text"
                  id="listName"
                  name="listName"
                  value={listName}
                  onChange={(e) => setListName(e.target.value)}
                  //   className={`w-full bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block px-2.5 py-1`}
                  placeholder={`Enter Table Name`}
                  mandatory={formErrorData?.listName}
                  error="Please enter a list name"
                />
              </div>

              <div className="mb-3 pt-4">
                <label htmlFor="account_number" className="block mb-2 text-base text-535252 font-poppins">
                  Description
                </label>
                <textarea
                  type="description"
                  id="description"
                  name="description"
                  value={listDescription}
                  onChange={(e) => setListDescription(e.target.value)}
                  className="bg-white rounded border border-DFE2E5 focus:outline-none focus:ring-0 
                focus:border-1D5D9B text-gray-500 placeholder-gray-300 
                active:border active:border-DFE2E5 text-xs block w-full p-2.5 h-28"
                  placeholder="Enter Table Description"
                />

                {/* className="bg-white rounded border border-DFE2E5  focus:outline-hidden focus:ring-0 focus:border-1D5D9B text-gray-500 placeholder-gray-300active:border active:border-DFE2E5  text-xs block w-full p-2.5 h-28"
                placeholder={`What is your list about?`}
              /> */}
              </div>
            </div>
          )}

          {/*---------------------- 3rd icon--------------------------- */}
          {activeSection === "csv" && (
            <div className="flex flex-col items-center justify-start grow min-h-0 pt-5 w-full px-5">
              <div className="flex flex-col justify-center items-center gap-2  w-full h-[127px]  border border-gray-300 border-dashed rounded-md">
                <span className="text-sm text-[#AFAFAF] text-center">
                  Select a CSV file from your device.
                  <br />
                  <div className="flex flex-col items-start space-y-2">
                    <input
                      type="file"
                      ref={inputCsvRef}
                      onChange={handleFileCsvChange}
                      accept=".csv"
                      style={{ display: "none" }}
                    />
                    {!fileCsvName && (
                      <button
                        onClick={openFileCsvPicker}
                        className="px-4 py-2 m-auto bg-gray-200 text-black rounded hover:bg-gray-300 transition"
                      >
                        Upload File
                      </button>
                    )}

                    {fileCsvName && (
                      <p className="m-auto text-xs bg-gray-100 p-2 text-gray-700 rounded-md">
                        <span onClick={handleClearCsvFileInput} className="cursor-pointer hover:bg-gray-200 ml-4">
                          <CloseIcon sx={{ fontSize: "14px" }} className="text-[#C9CDD7]" />
                        </span>
                      </p>
                    )}
                  </div>
                </span>
              </div>
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div className=" bg-white py-4 pr-3 flex justify-end text-md w-full border-t border-DFE2E5 mt-auto px-3">
          <div className="px-2 gap-3 flex">
            <Button variant={"secondary"} onClick={onClose}>
              Cancel
            </Button>

            <Button
              isLoading={apiLoading}
              variant={"primary"}
              type={"submit"}
              onClick={() => handleCreateList(listName, listDescription)}
            >
              {apiLoading ? "Saving..." : "Save"}
            </Button>
          </div>
        </div>
      </div>
    </CustomDrawer>
  );
}
